import { Link } from "react-router-dom";

/* Pre-sharpened WebP renditions in /public/logo so the mark stays crisp at every size & pixel density */
const SRC_SET = [96, 128, 160, 192, 224, 256, 288, 336, 384, 512].map((s) => `/logo/logo-${s}.webp ${s}w`).join(", ");

export const LogoImage = ({ sizes, className = "", testId, alt = "Five Point Cleaning" }) => (
  <img
    src="/logo/logo-192.webp"
    srcSet={SRC_SET}
    sizes={sizes}
    alt={alt}
    width="192"
    height="192"
    decoding="async"
    data-testid={testId}
    className={`rounded-full object-cover shrink-0 select-none ${className}`}
    draggable={false}
  />
);

export const Logo = () => (
  <Link to="/" data-testid="brand-logo" className="flex items-center group rounded-full">
    <LogoImage
      sizes="(min-width: 640px) 96px, 60px"
      className="h-[60px] w-[60px] sm:h-24 sm:w-24 shadow-lg shadow-black/25 ring-1 ring-rosegold/40 group-hover:ring-2 group-hover:ring-rosegold group-hover:shadow-xl group-hover:shadow-rosegold-base/30 transition-shadow duration-200"
    />
    <span className="sr-only">Five Point Cleaning — Home</span>
  </Link>
);
